import { createRouter, createWebHistory } from 'vue-router'
import qs from '@halobear/utils/qs'
import statistics from '@/utils/statistics'

import routes from './routes'

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  scrollBehavior: () => ({ y: 0 }),
  routes,
})

statistics.init()

router.afterEach((route) => {
  statistics.trackPageView(route.fullPath)
  // 设置路由title
  const urlTitle = route.query.title || qs.get('title')
  const title = urlTitle || (route.meta || {}).title || process.env.VUE_APP_TITLE
  title && (document.title = title)
})

export default router
